"use strict";

var _regeneratorRuntime = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchWithTimeout = void 0;

var tslib_1 = require("tslib");

var cross_fetch_1 = tslib_1.__importDefault(require("cross-fetch"));

var node_abort_controller_1 = tslib_1.__importDefault(require("node-abort-controller"));

var RequestError_1 = require("./RequestError");
/**
 * Simple Fetch wrapper that enables a timeout.
 * Allows for showing an error state for slow-to-load IPFS files
 */


var FetchWithTimeout = /*#__PURE__*/function () {
  function FetchWithTimeout() {
    var timeoutDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
    var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    _classCallCheck(this, FetchWithTimeout);

    this.controller = new node_abort_controller_1.default();
    this.expectedContentType = contentType;
    this.timeoutDuration = timeoutDuration; // Bind context to class

    this.fetch = this.fetch.bind(this);
  }

  _createClass(FetchWithTimeout, [{
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
        var options,
            _a,
            controller,
            response,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                controller = this.controller;
                _context.next = 4;
                return cross_fetch_1.default(url, _objectSpread(_objectSpread({}, options), {}, {
                  signal: this.controller.signal
                }));

              case 4:
                response = _context.sent;
                setTimeout(function () {
                  return controller.abort();
                }, this.timeoutDuration);

                if (!(response.status !== 200)) {
                  _context.next = 8;
                  break;
                }

                throw new RequestError_1.RequestError("Request Status = ".concat(response.status));

              case 8:
                if (!(this.expectedContentType && !((_a = response.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.startsWith(this.expectedContentType)))) {
                  _context.next = 10;
                  break;
                }

                throw new RequestError_1.RequestError('Reponse Content Type incorrect');

              case 10:
                return _context.abrupt("return", response);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
  }]);

  return FetchWithTimeout;
}();

exports.FetchWithTimeout = FetchWithTimeout;